import React from 'react';
import Concept from 'components/Tvendo/Shopping/DataMaster/Concept/Concept.js';

export default function () {
  return <Concept />;
}
